import Axios from 'axios'
import { AssociationUrl } from '../../config/properties';

const updateCapabilities = async (orgId, capabilities) => {
  const uCapabilities = {};
  Object.keys(capabilities).forEach(c => {
    const cap = capabilities[c];
    if (Array.isArray(cap)) {
      if (cap.length !== 0) {
        uCapabilities[c] = cap;
      }
    } else if (cap !== null && cap !== false && cap !== "false" && cap !== "") {
      uCapabilities[c] = cap;
    }
  });
  console.log("Update dynamodb capabilities:", uCapabilities);
  try {
    const resp = await Axios.put(`${AssociationUrl}/updateCapabilities?orgId=${orgId}`, uCapabilities);
    console.log("Update dynamodb:", resp);
  } catch (error) {
    console.log("Update dynamodb error:", error);
  }
}

export default updateCapabilities;


// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/updateCapabilities.jsx